import * as React from "react";
import { Navigate } from "react-router-dom";
import AccessDenied from "./AccessDenied";
import WebService from "../Services/WebService";
export type ProtectedRouteProps = {
  authenticationPath: string;
  outlet: React.ReactElement;
  allowed: boolean;
};

export default function ProtectedRoute({
  authenticationPath,
  outlet,
  allowed,
}: ProtectedRouteProps) {
  if (sessionStorage.getItem("access_token") != null) {
    if (!allowed) {
      return <AccessDenied />;
    }
    return outlet;
  } else {
    WebService.clearAuthSession();
    return <Navigate to={authenticationPath} replace />;
  }
}
